import { atom } from '@reatom/core';
import { OauthProvider } from '##/types/oauth';

export const providersAtom = atom<OauthProvider[]>([]);
